export const clinicsConfig = {
  key: "clinics",
  userInteractionKey: "user-clinic-interaction",
  itemsPerPage: 6,
};
